import { render } from "./ImageCaption.vue?vue&type=template&id=7a4f0305&scoped=true"
import script from "./ImageCaption.vue?vue&type=script&lang=js"
export * from "./ImageCaption.vue?vue&type=script&lang=js"

import "./ImageCaption.vue?vue&type=style&index=0&id=7a4f0305&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4f0305"]])

export default __exports__